"use strict";
/// <reference path="irep.js"/>

IREP.contactus = (function() {
    var submitButton, failureMessage, successMessage, successMessage2, txtMessage, hfEmailSupport, missingMessage, txtFirstName, txtLastName, txtEmail, emailSupport;
    var init = function(options) {
        submitButton = options.submitButton;
        failureMessage = options.failureMessage;
        successMessage = options.successMessage;
        successMessage2 = options.successMessage2;
        txtMessage = options.txtMessage;
        emailSupport = options.emailSupport;
        //hfEmailSupport = options.hfEmailSupport;
        missingMessage = options.missingMessage;
        txtFirstName = options.txtFirstName;
        txtLastName = options.txtLastName;
        txtEmail = options.txtEmail;

        //$("#closeContactUs").on("click", function() {

        //    if ($("#divMessage").html().indexOf("Intel") > 0 || $("#divMessage").html().indexOf("英特尔® 零售先锋 计划团队") > 0) //check to see if thank you message appears
        //    {
        //        $("#contactUs").css("visibility", "hidden");
        //        $("#divMessage").html("");
        //        IREP.master.contactUsOpenStatus(false);
        //        var height = IREP.contactus.getPopupHeight();
        //        $('#contactUs').css("bottom", '-=' + height);
        //    } else {
        //        IREP.master.contactUsToggle();
        //    }
        //    displayForm();
        //    return false;
        //});

        $(submitButton).click(function() {
            if (validateForm()) {
                var objContactUs =
                {
                    FirstName: IREP.options.user.firstName,
                    LastName: IREP.options.user.lastName,
                    Email: IREP.options.user.email,
                    StoreCode: IREP.options.user.storeCode,
                    StoreChainName: IREP.options.user.storeChainName,
                    UserType: IREP.options.user.userType,
                    UserTypeId: IREP.options.user.userTypeId,
                    GeoCode: IREP.options.user.geoCode,
                    CultureCode: IREP.options.user.cultureCode,
                    EmailSupport: emailSupport,
                    CountryCode: IREP.options.user.countryCode,
                    StoreChainId: IREP.options.user.storeChainId,
                    Site: IREP.options.user.site
                };

                //non-authenticated users
                if (IREP.options.user.email === undefined) {
                    objContactUs.FirstName = $(txtFirstName).val();
                    objContactUs.LastName = $(txtLastName).val();
                    objContactUs.Email = $(txtEmail).val();
                    objContactUs.GeoCode = $.cookie("IREPRegion");
                    objContactUs.Language = $.cookie("IREPLanguage");
                    objContactUs.UserType = "";
                    objContactUs.EmailSupport = "";
                    objContactUs.Site = IREP.options.user.site;
                }

                objContactUs.Message = $.trim($(txtMessage).val());
                clearMessage();
                if (objContactUs.Message !== "") {
                    IREP.leaderboard.block($(".contact-us-wrapper"));
                    IREP.callApi("communications/contactus", "POST", { cu: objContactUs })
                        .done(function() {
                            $("#divMessage").html('<span class="contact-us-success">' + successMessage + '<br><br>' + successMessage2 + '</span>');
                            $(txtMessage).val('');
                            //$('#divMessage').css("color", "white"); //reset in case of failure from multiple submits
                            hideForm();
                            ($(".contact-us-wrapper")).unblock();
                        })
                        .fail(function(data) {
                            $("#divMessage").html('<span class="contact-us-fail">' + failureMessage + '</span>');
                            ($(".contact-us-wrapper")).unblock();
                        });
                }
            }
            return false;
        });
    };

    var validateForm = function() {
        var isValid = true;
        $(".contact-us-error").hide();
        if (IREP.options.user.email === undefined) {

            // validate first name (required)
            var firstName = $.trim($(txtFirstName).val());
            if (firstName === "") {
                $(txtFirstName + "Required").show();
                isValid = false;
            }

            // validate last name (required)
            var lastName = $.trim($(txtLastName).val());
            if (lastName === "") {
                $(txtLastName + "Required").show();
                isValid = false;
            }

            // validate email (required, regex)
            var email = $.trim($(txtEmail).val());
            if (email === "") {
                $(txtEmail + "Required").show();
                isValid = false;
            } else if (!(/\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/.test(email))) {
                $(txtEmail + "Regex").show();
                isValid = false;
            }
        }

        // validate message (required)
        var message = $.trim($(txtMessage).val());
        if (message === "") {
            $(txtMessage + "Required").show();
            isValid = false;
        }

        return isValid;
    };

    var hideForm = function() {
        $("#contactUsExternalUsers,#contactUsExternalUsers_asmo, #contactCopy_ASMO").css("display", "none");
        $("#contactUsAllUsers").css("display", "none");
    }
    
    var displayForm = function() {
        if (IREP.options.user.email !== undefined) {
            $("#contactUsExternalUsers, #contactUsExternalUsers_asmo, #contactCopy_ASMO").hide();
        } else {
            $("#contactUsExternalUsers, #contactUsExternalUsers_asmo, #contactCopy_ASMO").show();
        }
        $("#contactUsAllUsers").show();
    }

    var clearMessage = function() {
        $("#divMessage").html('');
    };
    
    var getPopupHeight = function () {
        var height;
        if (IREP.options.user.email !== undefined) {
            height = "450px";
            $("#contactUsExternalUsers, #contactUsExternalUsers_asmo, #contactCopy_ASMO").hide();
            $("#contactUs").css("margin-bottom", "-" + height);
        } else {
            height = "620px";
            $("#contactUsExternalUsers, #contactUsExternalUsers_asmo, #contactCopy_ASMO").show();
            $("#contactUs").css("margin-bottom", "-" + height);
        }
        return height;
    }

    return {
        init: init,
        clearMessage: clearMessage,
        getPopupHeight: getPopupHeight,
        displayForm: displayForm
    };
})();